module.exports = __webpack_public_path__ + "static/signal_mobile_hero1.1c20972b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/_images/signal_mobile_hero1.svg
// module id = 491
// module chunks = 35783957827783